<h1 mat-dialog-title>Insumo de maleta</h1>
<mat-dialog-content class="mat-typography">
  <form [formGroup]="productForm">

    <mat-form-field appearance="outline">
      <mat-label>Número de remisión</mat-label>
      <input matInput type="text" placeholder="Número de remisión" formControlName="sellOrderId"/>
      <mat-error>Número de remisión es <strong>requerido</strong></mat-error>
    </mat-form-field>

    <mat-form-field class="input-full-width" appearance="outline">
      <mat-label>Código</mat-label>
      <input type="text" matInput formControlName="code" [matAutocomplete]="auto">
      <mat-autocomplete #auto="matAutocomplete" [displayWith]="productsDisplayFn">
        @for (product of filteredProductsFilter | async; track product) {
          <mat-option matTooltip="{{product.code}} - {{product.description}}" [value]="product">
            {{product.code}} - {{product.description}}
          </mat-option>
        }
      </mat-autocomplete>
      <mat-error>Código de insumo es <strong>requerido</strong></mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Lote</mat-label>
      <input matInput type="text" placeholder="Lote de insumo" formControlName="batch"/>
      <mat-error>Lote de insumo es <strong>requerido</strong></mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Fecha de caducidad</mat-label>
      <input matInput type="date" formControlName="expiration"/>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Cantidad</mat-label>
      <input matInput type="number" min="1" formControlName="quantity"/>
    </mat-form-field>


  </form>

</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close color="warn">Cerrar</button>
  <button mat-raised-button (click)="saveProduct()">Guardar</button>
</mat-dialog-actions>
